(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apix-business"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.apix-b2b__tabs').forEach((tabs)=>{tabs.addEventListener('click',(event)=>{const button=event.target.closest('[data-service-tab]');if(!button)return;const root=tabs.closest('.apix-b2b');tabs.querySelectorAll('[data-service-tab]').forEach((item)=>{const active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',active?'true':'false')});root.querySelectorAll('[data-service-panel]').forEach((panel)=>{panel.hidden=panel.dataset.servicePanel!==button.dataset.serviceTab})})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
